import React, { useEffect, useState } from 'react'
import { Avatar,Button,Input,message, Select, Table, Tag } from 'antd'
import { SERVER_ADDRESS } from '../../Config/Config';
import axios from 'axios';
import { EyeOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ReportedUsers = () => {
    const [user,setUser] = useState([]);
    const [searchTerm,setSearchTerm] = useState(null);
    const [gender,setGender] = useState(null);
    const [filterUser,setFilterUser] = useState([]);
    const navigate = useNavigate();
    const fetchUsers = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/reportedUsers`);
            if(response.status === 200){
                setUser(response.data.data);
                setFilterUser(response.data.data)
            }
        } catch (error) {
            console.log(error);
            if(error.response.status===500) message.error({content:"Internal Server Error",duration:2})
        }
    }

    useEffect(()=>{
        fetchUsers();
    },[])

    const handleNavigation = async(id,is_suspend)=>{
        navigate(`/reportList/${id}`,{state:{is_suspend}})
    }

    useEffect(()=>{
        applyFilter();
    },[searchTerm,gender])

    const applyFilter = ()=>{
        let filtered = user;
        if(searchTerm === ''){
            setFilterUser(user);
        }
        else if(searchTerm){
            filtered = filtered.filter((user)=>
                user.name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        }

        if (gender !== null) {
            filtered = filtered.filter((user) => user.gender == gender);
        }

        setFilterUser(filtered)
    }

    const columns = [{
        title:"Id",
        dataIndex:'id',
        key:'id',
        sorter:(a,b)=>a.id-b.id
    },
    {
        title:"Profile",
        dataIndex:"photo",
        key:"photo",
        render:(_,record)=>{
           return (
            record.photo.length > 0 ? (
                <Avatar size={64} src={record.photo[0]} />
            ) : (
                <Avatar size={64} icon={<UserOutlined />} />
            )
           )
        }
    },
    {
        title:"Name",
        dataIndex:"name",
        key:"name",
        sorter:(a,b)=>a.name.localeCompare(b.name)
    },
    {
        title:"Gender",
        dataIndex:"gender",
        key:"gender",
        render:(_,record)=>{
            return(
                record.gender === "1" ? (
                    <Tag color='blue' >Groom</Tag>
                ):(
                    <Tag color='magenta' >Bride</Tag>
                )
            )
        }
    },
    {
        title:"Email",
        dataIndex:"email",
        key:"email",
    },
    {
        title:"Phone",
        dataIndex:"phone",
        key:"phone"
    },
    {
        title:"Total Reports",
        dataIndex:"total_reports",
        key:"total_reports",
        sorter:(a,b)=>a.total_reports-b.total_reports
    },
    {
        title:"Option",
        dataIndex:"",
        key:"option",
        render:(_,record)=>{
            return (
                <>
                <div className='d-flex flex-row gap-2' >
                <Button color='primary' variant='filled' onClick={()=>handleNavigation(record.id,record.is_suspend)} ><EyeOutlined /></Button>
                </div>
                </>
            )
        }
    }]

    const genderOption =[
        {
            label:"Groom",
            value:'1'
        },
        {
            label:"Bride",
            value:"2"
        }
    ]

  return (
    <>
    <div className='' style={{marginTop:'4rem'}} >
    <div className='d-flex flex-row justify-content-between mb-3' >
    <h3>Reported Users</h3>
    </div>
    <div className='d-flex flex-row gap-4 mb-3' >
        <Input style={{width:'14rem'}} onChange={(e)=>setSearchTerm(e.target.value)} placeholder='Search By Name' prefix={<SearchOutlined />} />
        <Select style={{width:'14rem'}} onChange={(e)=>setGender(e)} options={genderOption} placeholder='Select by Gender' />
    </div>
    <div style={{overflowX:'auto'}} >
    <Table dataSource={filterUser} rowKey={'id'} columns={columns} />
    </div>
    </div>
    </>
  )
}

export default ReportedUsers